export const RESPONSES_RESET_STATE = 'RESPONSES_RESET_STATE';
export const RESPONSES_CURRENT_ITEM = 'RESPONSES_CURRENT_ITEM';
 
export const RESPONSES_REQUEST_LOADING = 'RESPONSES_REQUEST_LOADING';
export const RESPONSES_REQUEST_SUCCESS = 'RESPONSES_REQUEST_SUCCESS';
export const RESPONSES_REQUEST_FAILED = 'RESPONSES_REQUEST_FAILED';
 
export const RESPONSES_CURRENT_ACTION = 'RESPONSES_CURRENT_ACTION';
export const RESPONSES_RESET_ACTION = 'RESPONSES_RESET_ACTION';